import { ConstantConfig } from 'src/config';

export const EWASTE_SERVICE_ID = ConstantConfig.eWasteServiceId;
export const UCO_WASTE_SERVICE_ID = ConstantConfig.ucoWasteServiceId;
export const PLASTIC_WASTE_SERVICE_ID = ConstantConfig.plasticWasteServiceId;
export const TEXTILE_WASTE_SERVICE_ID = ConstantConfig.textileWasteServiceId;
export const PLASTIC_CATEGORY_ID = ConstantConfig.plasticCategoryId;
export const UCO_CATEGORY_ID = ConstantConfig.ucoCategoryId;
export const TEXTILE_CATEGORY_ID = ConstantConfig.textileCategoryId;
export const PLASTIC_REQUEST_ID_PREFIX = 'PREQ';
export const UCO_REQUEST_ID_PREFIX = 'UREQ';
export const TEXTILE_REQUEST_ID_PREFIX = 'TREQ';
export const EWASTE_CATEGORY_IDS = ConstantConfig.ewasteCategoryIds;

export const WeekDays = [
  {
    label: 0,
    value: 'Sunday',
  },
  {
    label: 1,
    value: 'Monday',
  },
  {
    label: 2,
    value: 'Tuesday',
  },
  {
    label: 3,
    value: 'Wednesday',
  },
  {
    label: 4,
    value: 'Thursday',
  },
  {
    label: 5,
    value: 'Friday',
  },
  {
    label: 6,
    value: 'Saturday',
  },
];
